<template>
  <div>
    <van-field label="省市区" :value="displayText" clickable readonly is-link @click="init"></van-field>
    <van-popup v-model="show" round position="bottom">
      <van-picker
              ref="picker"
              show-toolbar
              :columns="columns"
              @cancel="onClose"
              @confirm="onConfirm"
              @change="onChange"
              :loading="loading"
              value-key="AreaName"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Cell, Popup, Picker } from "vant";
import { httpOpen } from "../scripts/network";

Vue.use(Cell);
Vue.use(Popup);
Vue.use(Picker);
const CachedData = {};

export default {
  name: "AreaPicker",
  data() {
    return {
      loading: false,
      show: false,
      columns: [{ values: [] }, { values: [] }, { values: [] }],
    };
  },
  props: ["areaCode", "areaText"],
  computed: {
    displayText() {
      if (this.areaText && this.areaCode) {
        return this.areaText;
      } else {
        return "请选择省市区";
      }
    },
  },
  async created () {
      this.columns[0].values = await this.getAreas(1, 0); // 先加载省
  },
  methods: {
    async getAreas(level, parentSysNo) {
      let d = CachedData[parentSysNo];
      if (d && d.length > 0) {
        return d;
      } else {
        const response = await httpOpen("/Common/GetAreaList", {
          type: "post",
          body: { AreaLeval: level, ParentSysNo: parentSysNo },
        });
        let items = response.Data || [];
        CachedData[parentSysNo] = items;
        return items;
      }
    },
    async init() {
      let nextParentSysNo = this.columns[0].values[0].SysNo;
      let pickIndexs = [0,0,0];

      // 选中默认省
      if (this.areaCode) {
        for (let index = 0; index < this.columns[0].values.length; index++) {
          let item = this.columns[0].values[index];
          if (this.areaCode.startsWith(item.Code)) {
            pickIndexs[0] = index;
            nextParentSysNo = item.SysNo;
          }
        }
      }

      const city = await this.getAreas(2, nextParentSysNo);
      this.columns[1].values = city;
      nextParentSysNo = city[0].SysNo;

      // 选中默认市
      if (this.areaCode) {
        for (let index = 0; index < this.columns[1].values.length; index++) {
          let item = this.columns[1].values[index];
          if (this.areaCode.startsWith(item.Code)) {
            pickIndexs[1] = index;
            nextParentSysNo = item.SysNo;
          }
        }
      }

      const county = await this.getAreas(3, nextParentSysNo);
      this.columns[2].values = county;
      nextParentSysNo = county[0].SysNo;

      // 选中默认区
      if (this.areaCode) {
        for (let index = 0; index < this.columns[2].values.length; index++) {
          let item = this.columns[2].values[index];
          if (this.areaCode.startsWith(item.Code)) {
            pickIndexs[2] = index;
            nextParentSysNo = item.SysNo;
          }
        }
      }
      this.show = true;
      this.$nextTick(()=>{
          this.$refs.picker.setIndexes(pickIndexs);
      })
    },
    onConfirm(value) {
      this.show = false;
      this.$emit("confirm", value);
    },
    onClose() {
      this.show = false;
      this.$emit("close");
    },
    async onChange(picker, value, index) {
      if (index == 0) {
        const city = await this.getAreas(2, value[0].SysNo);
        this.columns[1].values = city;

        const county = await this.getAreas(3, city[0].SysNo);
        this.columns[2].values = county;

        this.$emit("change", [value[0], city[0], county[0]]);
      }

      if (index == 1) {
        const county = await this.getAreas(3, value[1].SysNo);
        this.columns[2].values = county;

        this.$emit("change", [value[0], value[1], county[0]]);
      }
    },
  },
};
</script>